var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"flex items-center justify-between flex-wrap p-8"},[_c('app-logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }